import { render, staticRenderFns } from "./ContactDetails.html?vue&type=template&id=c979cf6e&scoped=true&"
import script from "./ContactDetails.js?vue&type=script&lang=js&"
export * from "./ContactDetails.js?vue&type=script&lang=js&"
import style0 from "./ContactDetails.scss?vue&type=style&index=0&id=c979cf6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c979cf6e",
  null
  
)

export default component.exports